/* unplugin-vue-components disabled */import { render } from "./add-modal.vue?vue&type=template&id=74da3e4e&scoped=true"
import script from "./add-modal.vue?vue&type=script&lang=js"
export * from "./add-modal.vue?vue&type=script&lang=js"

import "./add-modal.vue?vue&type=style&index=0&id=74da3e4e&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74da3e4e"],['__file',"src/pages/sh-companies/add-modal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "74da3e4e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('74da3e4e', __exports__)) {
    api.reload('74da3e4e', __exports__)
  }
  
  module.hot.accept("./add-modal.vue?vue&type=template&id=74da3e4e&scoped=true", () => {
    api.rerender('74da3e4e', render)
  })

}


export default __exports__